import { Link } from "react-router-dom";

const stats = [
  { value: "5000+", label: "累计资讯" },
  { value: "1200+", label: "收录作品" },
  { value: "60+", label: "主题专题" },
  { value: "每日", label: "内容更新" },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-16">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-gradient-to-br from-secondary-950 via-secondary-900 to-secondary-800">
        <div className="grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-2 lg:items-center lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-information-line text-sm" />
              关于 91动漫
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-white md:text-3xl">
              你的动漫资讯与发现伙伴
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-secondary-100/85 md:text-base">
              91动漫致力于为动漫爱好者提供清晰、及时的资讯与推荐服务。我们聚合动漫新闻动态、整理作品资料、
              策划主题专题，帮助你快速了解行业动态，发现真正值得一看的作品。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/news"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-white/20 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-white/10"
              >
                浏览资讯
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-white/5 p-5 backdrop-blur-sm">
                <div className="font-heading text-2xl font-extrabold text-accent-300 md:text-3xl">{s.value}</div>
                <div className="mt-1 text-sm text-secondary-100/80">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}